module.exports = __webpack_public_path__ + "img/cooperation23.df8539eb.png";